import { selectors as commonSelectors } from '~/domains/common';
import { selectors as agentScannersSelectors } from '~/domains/agentScanners';
import { isLoggedIn } from '~/utils/validations/profile';

const resolve = async ({ getState }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);

  isLoggedIn(profile);

  if (!agentScannersSelectors.isAgentScannersFlagEnabled(state)) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }
};

export default resolve;
